module.exports = __webpack_public_path__ + "img/walletconnect.c2d87ea8.svg";